webpackJsonp([25],{

/***/ 1009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_filter_vue__ = __webpack_require__(944);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6ab43e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_filter_vue__ = __webpack_require__(1010);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6ab43e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-autocomplete',{attrs:{"background-color":"white","box":"","disabled":_vm.disabled,"height":48,"hide-details":"","item-text":"name","item-value":"id","items":_vm.customers,"label":"Cliente","loading":_vm.isLoading,"readonly":_vm.disabled,"return-object":"","search-input":_vm.search,"value":_vm.newCustomerId},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event},"input":_vm.setCustomerId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_action_bar_action_bar__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_companies_company_filter__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_companies_company_list__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_lib__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_app_actions_app_actions__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_back_button_route__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_action_codes__ = __webpack_require__(832);





var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
		var dataUserInfo, newCustomerId, _ref2, headers;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						dataUserInfo = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
						newCustomerId = dataUserInfo.subsidiary.customerId;

						if (this.customerId) {
							this.params.customerId = Number(this.customerId) || newCustomerId;
						}
						this.$setCurrentSubsidiary({});
						this.$loadSubsidiaries({ context: this, params: this.params });
						_context.next = 7;
						return this.loadData('subsidiary');

					case 7:
						_ref2 = _context.sent;
						headers = _ref2.headers;

						this.itemsTotalQuantity = Number(headers['x-quantity']);

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

var changePage = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(page) {
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.currentPage = page;
						this.params.page = page;
						_context2.next = 4;
						return this.loadData('subsidiary');

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function changePage(_x) {
		return _ref3.apply(this, arguments);
	};
}();

var loadCustomers = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
		var uri, newParams, _ref5, customers;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						this.isLoading = true;
						uri = params.customerId ? 'customer/' + params.customerId : 'customer';
						newParams = params.search ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params) : null;
						_context3.next = 5;
						return this.$http.get(uri, { params: newParams });

					case 5:
						_ref5 = _context3.sent;
						customers = _ref5.data;

						this.isLoading = false;
						if (params.customerId) {
							this.customers = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, customers)];
							this.customerSelected = customers.id;
							this.customerName = customers.name + ' ' + customers.lastname;
							this.params.customerId = this.customerSelected;
							this.loadData('subsidiary');
						} else {
							this.customers = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(customers));
						}

					case 9:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadCustomers(_x2) {
		return _ref4.apply(this, arguments);
	};
}();

var onDelete = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.prev = 0;
						_context4.next = 3;
						return this.$http.patch('subsidiary/' + this.companyId + '/disable');

					case 3:
						this.showNotification('La empresa ha sido eliminada correctamente.');
						this.closeDialog();
						this.params.page = 1;
						this.currentPage = 1;
						this.loadData('subsidiary');
						_context4.next = 13;
						break;

					case 10:
						_context4.prev = 10;
						_context4.t0 = _context4['catch'](0);

						if (_context4.t0.status === 500) {
							this.showGenericError();
						}

					case 13:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[0, 10]]);
	}));

	return function onDelete() {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










function closeDialog() {
	this.dialog = false;
	this.dialogMessage = '';
	this.companyId = null;
}

function openConfirmation(_ref7) {
	var id = _ref7.id,
	    name = _ref7.name;

	this.companyId = id;
	this.dialogMessage = '\xBFDesea eliminar la empresa ' + name + ' del listado?';
	this.dialog = true;
}

function rowIsSelected(company) {
	this.dataSelected = [];
	var id = company.id,
	    name = company.name,
	    customerId = company.customerId,
	    isSelected = company.isSelected;

	this.$setCurrentSubsidiary(isSelected ? company : {});
	if (isSelected) {
		this.dataSelected.push({ id: id, customerId: customerId, name: name });
		this.onlyOneIsSelected(this.getSubsidiaries, id);
	}
}

function onlyOneIsSelected(subsidiaries, id) {
	var newSub = __WEBPACK_IMPORTED_MODULE_8__shared_lib__["a" /* default */].map(__WEBPACK_IMPORTED_MODULE_8__shared_lib__["a" /* default */].setNewProperty('isSelected', function (item) {
		return item.id === id;
	}), subsidiaries);
	this.$updateSubsidiaries(newSub);
}

function runAction(_ref8) {
	var codeWeb = _ref8.codeWeb;

	if (codeWeb !== 'company-new') {
		var _dataSelected$ = this.dataSelected[0],
		    id = _dataSelected$.id,
		    customerId = _dataSelected$.customerId,
		    name = _dataSelected$.name;

		if (codeWeb === __WEBPACK_IMPORTED_MODULE_11__shared_action_codes__["a" /* ACCOUNTING_DEFINITION */]) {
			this.goTo('account-definitions', { query: { subsidiaryId: id, customerId: customerId, name: name } });
		} else {
			this.goTo(codeWeb, {
				params: { customerId: customerId, subsidiaryId: id }, query: { subsidiaryId: id, customerId: customerId, name: name }
			});
		}
	} else {
		var _customerId = this.params.customerId;
		var customerName = this.$route.params.customerName;

		this.goTo(codeWeb, { params: { customerId: _customerId, customerName: customerName } });
	}
}

function title() {
	var customerName = this.$route.params.customerName;

	var fullName = customerName ? customerName.split('-').join(' ').toLowerCase() : null;
	var pageTitle = this.$route.meta.title;
	return this.customerId ? fullName + ' > ' + pageTitle : pageTitle;
}

function valueDisabled() {
	if (this.dataSelected.length !== 1) {
		return [{ code: __WEBPACK_IMPORTED_MODULE_11__shared_action_codes__["a" /* ACCOUNTING_DEFINITION */], disabled: true }, { code: __WEBPACK_IMPORTED_MODULE_11__shared_action_codes__["l" /* ACCOUNTING_RULE_LIST */], disabled: true }, { code: __WEBPACK_IMPORTED_MODULE_11__shared_action_codes__["j" /* ACCOUNTING_PARAMETRIZATION */], disabled: true }];
	}
	return [];
}

function data() {
	return {
		columns: [{ id: 1, name: 'Fecha de Inicio', value: 'createdAt', checked: true, visible: true, movil: true }, { id: 2, name: 'Nombre', value: 'name', checked: true, visible: true, movil: false }, { id: 3, name: 'Ruc', value: 'ruc', checked: true, visible: true, movil: true }, { id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true, movil: false }],
		companyId: null,
		currentPage: 1,
		customerName: '',
		itemsTotalQuantity: null,
		customers: [],
		customerSelected: 0,
		dataSelected: [],
		dialog: false,
		dialogMessage: '',
		isLoading: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-company',
	components: {
		actionBar: __WEBPACK_IMPORTED_MODULE_5__components_shared_action_bar_action_bar__["a" /* default */],
		companyFilter: __WEBPACK_IMPORTED_MODULE_6__components_companies_company_filter__["a" /* default */],
		companyList: __WEBPACK_IMPORTED_MODULE_7__components_companies_company_list__["a" /* default */],
		appActions: __WEBPACK_IMPORTED_MODULE_9__components_shared_app_actions_app_actions__["a" /* default */],
		backButtonRoute: __WEBPACK_IMPORTED_MODULE_10__components_shared_back_button_route__["a" /* default */]
	},
	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('subsidiary', ['getSubsidiaries']), {
		title: title,
		valueDisabled: valueDisabled
	}),
	created: created,
	data: data,
	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('subsidiary', {
		$loadSubsidiaries: 'loadSubsidiaries',
		$setCurrentSubsidiary: 'setCurrentSubsidiary',
		$updateSubsidiaries: 'updateSubsidiaries'
	}), {
		changePage: changePage,
		closeDialog: closeDialog,
		loadCustomers: loadCustomers,
		onDelete: onDelete,
		onlyOneIsSelected: onlyOneIsSelected,
		openConfirmation: openConfirmation,
		rowIsSelected: rowIsSelected,
		runAction: runAction
	}),
	props: {
		customerId: [Number, String]
	},
	watch: {
		$route: function $route(newVal) {
			if (newVal) {
				if (newVal.name === 'companies') {
					if (this.customerId) {
						this.params.customerId = Number(this.customerId);
					}
				}
			}
		}
	}
});

/***/ }),

/***/ 1119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(109);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function edit(company) {
	var customerId = company.customerId,
	    id = company.id;
	var customerName = this.$route.params.customerName;

	this.goTo('company-edit', { params: { customerId: customerId, companyId: id, customerName: customerName } });
}

function goToAccountingPlans(company) {
	var id = company.id;

	this.$setCurrentSubsidiary(company);
	this.goTo('accounting-plans', { params: { subsidiaryId: id } });
}

function goToAccountingPeriods(company) {
	var id = company.id,
	    name = company.name;

	this.$setCurrentSubsidiary(company);
	this.goTo('accounting-periods', { params: { subsidiaryId: id, subsidiaryName: name.split(' ').join('-') } });
}

function goToCostCenters(company) {
	var id = company.id,
	    name = company.name;

	this.$setCurrentSubsidiary(company);
	this.goTo('costs-centers', { query: { subsidiaryId: id, subsidiaryName: name.split(' ').join('-') } });
}

function goToModules(company) {
	var customerId = company.customerId,
	    id = company.id,
	    name = company.name;

	this.$setCurrentSubsidiary(company);
	this.goTo('accounting-modules', { query: { subsidiaryId: id, name: name, customerId: customerId } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}
function data() {
	return {
		iconWidth: 10
	};
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'company-list',
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */]
	},
	data: data,
	props: {
		columns: {
			type: Array,
			required: true
		},
		currentPage: {
			type: Number,
			default: 1
		},
		lastPage: {
			type: Number,
			default: 0
		},
		itemsTotalQuantity: {
			type: Number,
			default: 1
		},
		itemsQuantity: {
			type: Number,
			default: 1
		},
		rows: {
			type: Array,
			required: true
		}
	},
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('subsidiary', {
		$setCurrentSubsidiary: 'setCurrentSubsidiary'
	}), {
		edit: edit,
		goToAccountingPeriods: goToAccountingPeriods,
		goToAccountingPlans: goToAccountingPlans,
		goToCostCenters: goToCostCenters,
		goToModules: goToModules,
		onSearch: onSearch
	})
});

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_list_vue__ = __webpack_require__(1119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e090c1f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_list_vue__ = __webpack_require__(1287);
function injectStyle (ssrContext) {
  __webpack_require__(1285)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e090c1f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e090c1f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1286);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("f8e34fb4", content, true, {});

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.company-list[data-v-5e090c1f]{font-family:AvenirRegular!important;font-size:11px!important;padding-left:48px;padding-right:48px}@media(max-width:768px){.company-list[data-v-5e090c1f]{padding-left:10px;padding-right:10px}}@media(max-width:768px){.date[data-v-5e090c1f]{display:grid;grid-column:1/4;grid-row:2;white-space:nowrap}}@media(max-width:768px){.name[data-v-5e090c1f]{display:-webkit-box;display:-ms-flexbox;display:flex;grid-column:2/7;grid-row:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-left:0!important;text-overflow:ellipsis;white-space:nowrap}}.company-name[data-v-5e090c1f]{display:none}@media(max-width:768px){.company-name[data-v-5e090c1f]{display:inline-block;font-family:AvenirBold;margin-right:15px}}@media(max-width:768px){.ruc[data-v-5e090c1f]{display:grid;grid-column:4/8;grid-row:2}}@media(max-width:768px){.actions[data-v-5e090c1f]{grid-column:7/8;grid-row:1}}.btn-menu-content[data-v-5e090c1f]{border-bottom:1px solid #e5eaef}.menu-content[data-v-5e090c1f]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#f52c18;display:grid;font-family:AvenirRegular;font-size:12px!important;grid-column-gap:3px;grid-template-columns:15px 1fr;width:175px}.menu-content .accounting-periods[data-v-5e090c1f],.menu-content .accounting-plan[data-v-5e090c1f],.menu-content .cost-center[data-v-5e090c1f],.menu-content .modules[data-v-5e090c1f]{color:#006edb}.menu-content .edit[data-v-5e090c1f]{color:#33cfc7}.collapse-menu[data-v-5e090c1f]{display:none}@media(max-width:768px){.collapse-menu[data-v-5e090c1f]{display:block;grid-column:2/3;grid-row:1}.collapse-menu .v-menu[data-v-5e090c1f],.collapse-menu[data-v-5e090c1f]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.collapse-menu .v-menu[data-v-5e090c1f]{display:-webkit-box;display:-ms-flexbox;display:flex}.collapse-menu .v-menu .v-btn[data-v-5e090c1f]{background-color:#33cfc7;height:25px;margin:0;width:25px}}.btnActions[data-v-5e090c1f]{margin:0;background-color:#33cfc7;height:20px;width:20px}.btnClose[data-v-5e090c1f]{margin:0;background-color:#f58a93;height:20px;width:20px}", "", {"version":3,"sources":["/opt/build/repo/src/components/companies/company-list.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,+BAA+B,oCAAuC,yBAA0B,kBAAkB,kBAAkB,CACnI,AACD,wBACA,+BAA+B,kBAAkB,kBAAkB,CAClE,CACA,AACD,wBACA,uBAAuB,aAAa,gBAAgB,WAAW,kBAAkB,CAChF,CACA,AACD,wBACA,uBAAuB,oBAAoB,oBAAoB,aAAa,gBAAgB,WAAW,wBAAwB,qBAAqB,uBAAuB,yBAA4B,uBAAuB,kBAAkB,CAC/O,CACA,AACD,+BAA+B,YAAY,CAC1C,AACD,wBACA,+BAA+B,qBAAqB,uBAAyB,iBAAiB,CAC7F,CACA,AACD,wBACA,sBAAsB,aAAa,gBAAgB,UAAU,CAC5D,CACA,AACD,wBACA,0BAA0B,gBAAgB,UAAU,CACnD,CACA,AACD,mCAAmC,+BAA+B,CACjE,AACD,+BAA+B,yBAAyB,sBAAsB,mBAAmB,cAAc,aAAa,0BAA4B,yBAA0B,oBAAoB,+BAA+B,WAAW,CAC/O,AACD,uLAAuL,aAAa,CACnM,AACD,qCAAqC,aAAa,CACjD,AACD,gCAAgC,YAAY,CAC3C,AACD,wBACA,gCAAkG,cAAc,gBAAgB,UAAW,CAC1I,AACD,wEAFgC,yBAAyB,sBAAsB,mBAAmB,AAAyC,YAAY,wBAAwB,qBAAqB,sBAAsB,CAGzN,AADD,wCAA0G,oBAAoB,oBAAoB,YAAa,CAC9J,AACD,+CAA+C,yBAAyB,YAAY,SAAS,UAAU,CACtG,CACA,AACD,6BAA6B,SAAS,yBAAyB,YAAY,UAAU,CACpF,AACD,2BAA2B,SAAS,yBAAyB,YAAY,UAAU,CAClF","file":"company-list.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.company-list[data-v-5e090c1f]{font-family:\"AvenirRegular\" !important;font-size:11px !important;padding-left:48px;padding-right:48px\n}\n@media(max-width: 768px){\n.company-list[data-v-5e090c1f]{padding-left:10px;padding-right:10px\n}\n}\n@media(max-width: 768px){\n.date[data-v-5e090c1f]{display:grid;grid-column:1/4;grid-row:2;white-space:nowrap\n}\n}\n@media(max-width: 768px){\n.name[data-v-5e090c1f]{display:-webkit-box;display:-ms-flexbox;display:flex;grid-column:2/7;grid-row:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-left:0px !important;text-overflow:ellipsis;white-space:nowrap\n}\n}\n.company-name[data-v-5e090c1f]{display:none\n}\n@media(max-width: 768px){\n.company-name[data-v-5e090c1f]{display:inline-block;font-family:\"AvenirBold\";margin-right:15px\n}\n}\n@media(max-width: 768px){\n.ruc[data-v-5e090c1f]{display:grid;grid-column:4/8;grid-row:2\n}\n}\n@media(max-width: 768px){\n.actions[data-v-5e090c1f]{grid-column:7/8;grid-row:1\n}\n}\n.btn-menu-content[data-v-5e090c1f]{border-bottom:1px solid #e5eaef\n}\n.menu-content[data-v-5e090c1f]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#f52c18;display:grid;font-family:\"AvenirRegular\";font-size:12px !important;grid-column-gap:3px;grid-template-columns:15px 1fr;width:175px\n}\n.menu-content .cost-center[data-v-5e090c1f],.menu-content .accounting-plan[data-v-5e090c1f],.menu-content .accounting-periods[data-v-5e090c1f],.menu-content .modules[data-v-5e090c1f]{color:#006edb\n}\n.menu-content .edit[data-v-5e090c1f]{color:#33cfc7\n}\n.collapse-menu[data-v-5e090c1f]{display:none\n}\n@media(max-width: 768px){\n.collapse-menu[data-v-5e090c1f]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:block;grid-column:2/3;grid-row:1;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.collapse-menu .v-menu[data-v-5e090c1f]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.collapse-menu .v-menu .v-btn[data-v-5e090c1f]{background-color:#33cfc7;height:25px;margin:0;width:25px\n}\n}\n.btnActions[data-v-5e090c1f]{margin:0;background-color:#33cfc7;height:20px;width:20px\n}\n.btnClose[data-v-5e090c1f]{margin:0;background-color:#f58a93;height:20px;width:20px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-list"},[_c('app-table',{staticClass:"mt-5 is-not-selectable",attrs:{"selectable":"","name":"companies","current-page":_vm.currentPage,"last-page":_vm.lastPage,"items-total-quantity":_vm.itemsTotalQuantity,"items-quantity":_vm.itemsQuantity,"columns":_vm.columns,"rows":_vm.rows},on:{"on-page":function($event){return _vm.$emit('on-page', $event)},"row-is-selected":function($event){return _vm.$emit('row-is-selected', $event)},"on-search-event":_vm.onSearch},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"date"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm._f("exactDate")(props.row.startDateOperations))+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}],staticClass:"name"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}],staticClass:"ruc"},[_vm._v(_vm._s(props.row.documentNumber))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}],staticClass:"actions",on:{"click":function($event){$event.stopPropagation();return _vm.stopClick.apply(null, arguments)}}},[_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"img":"/static/img/icons/centro-costos.svg","text":"Centros de Costos","color":"cyan","width":25},on:{"click-icon":function($event){return _vm.goToCostCenters(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"img":"/static/img/icons/plan-contable.svg","text":"Ver Plan Contable","width":25},on:{"click-icon":function($event){return _vm.goToAccountingPlans(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"img":"/static/img/icons/periodo-contable.svg","text":"Periodos Contables","width":25},on:{"click-icon":function($event){return _vm.goToAccountingPeriods(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"img":"/static/img/icons/modulo.svg","text":"Módulos","width":25},on:{"click-icon":function($event){return _vm.goToModules(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"color":"success","img":"/static/img/actions-list/edit.svg","text":"Editar Empresa","width":25},on:{"click-icon":function($event){return _vm.edit(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"img":"/static/img/actions-list/delete.svg","text":"Eliminar Empresa","width":25},on:{"click-icon":function($event){return _vm.$emit('delete-company', props.row)}}}),_vm._v(" "),_c('div',{staticClass:"collapse-menu"},[_c('v-menu',[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_horiz")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"btn-menu-content"},[_c('v-list-tile-title',{staticClass:"menu-content",on:{"click":function($event){return _vm.goToCostCenters(props.row)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/icons/centro-costos.svg","alt":"icono","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1 cost-center"},[_vm._v("Centro de costos")])])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"btn-menu-content"},[_c('v-list-tile-title',{staticClass:"menu-content",on:{"click":function($event){return _vm.goToAccountingPlans(props.row)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/icons/plan-contable.svg","alt":"icono","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1 accounting-plan"},[_vm._v("Ver Plan Contable")])])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"btn-menu-content"},[_c('v-list-tile-title',{staticClass:"menu-content",on:{"click":function($event){return _vm.goToAccountingPeriods(props.row)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/icons/periodo-contable.svg","alt":"icono","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1 accounting-periods"},[_vm._v("Periodos Contables")])])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"btn-menu-content"},[_c('v-list-tile-title',{staticClass:"menu-content",on:{"click":function($event){return _vm.goToModules(props.row)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/icons/modulo.svg","alt":"icono","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1 modules"},[_vm._v("Módulos")])])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"btn-menu-content"},[_c('v-list-tile-title',{staticClass:"menu-content",on:{"click":function($event){return _vm.edit(props.row)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/icons/edit.svg","alt":"icono","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1 edit"},[_vm._v("Editar empresa")])])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-title',{staticClass:"menu-content",on:{"click":function($event){return _vm.$emit('delete-company', props.row)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/actions-list/delete.svg","alt":"icono","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v("Eliminar")])])],1)],1)],1)],1)],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header-page',{attrs:{"actions":"","name":"companies","title":_vm.title,"value-disabled":_vm.valueDisabled},on:{"run-action":_vm.runAction}}),_vm._v(" "),_c('app-actions',{attrs:{"value-disabled":_vm.valueDisabled,"resource-uri":_vm.$route.name},on:{"run-action":_vm.runAction}}),_vm._v(" "),_c('backButtonRoute'),_vm._v(" "),_c('company-list',{attrs:{"columns":_vm.columns,"items-total-quantity":_vm.itemsTotalQuantity,"items-quantity":_vm.table.rows.length,"current-page":_vm.currentPage,"rows":_vm.table.rows,"last-page":_vm.table.lastPage},on:{"delete-company":_vm.openConfirmation,"on-page":_vm.changePage,"on-search":function($event){return _vm.onSearch($event, 'subsidiary')},"row-is-selected":_vm.rowIsSelected}}),_vm._v(" "),_c('v-dialog',{attrs:{"content-class":"confirmation-dialog","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"pa-4"},[_c('v-card-text',{staticClass:"title text-xs-center pt-4"},[_vm._v(_vm._s(_vm.dialogMessage))]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center pb-4"},[_c('v-btn',{staticClass:"btn-action mr-1 white--text",attrs:{"type":"button","color":"success"},on:{"click":_vm.closeDialog}},[_vm._v("\n\t\t\t\t\tCancelar\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action ml-1 white--text",attrs:{"type":"button","color":"error"},on:{"click":_vm.onDelete}},[_vm._v("\n\t\t\t\t\tEliminar\n\t\t\t\t")])],1)],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_company_vue__ = __webpack_require__(1118);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b5c9160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_company_vue__ = __webpack_require__(1288);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b5c9160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(791);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(233);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(792), __esModule: true };

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111);
__webpack_require__(64);
module.exports = __webpack_require__(793);


/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(113);
var ITERATOR = __webpack_require__(14)('iterator');
var Iterators = __webpack_require__(32);
module.exports = __webpack_require__(11).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(14);


/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var core = __webpack_require__(11);
var LIBRARY = __webpack_require__(68);
var wksExt = __webpack_require__(794);
var defineProperty = __webpack_require__(30).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(20);


//
//
//
//
//
//
//
//
//
//
//
//




function backRoute() {
	var getBread = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.getBreadCrumbs));
	getBread.pop();
	var lastRoute = getBread[getBread.length - 1];
	var options = {
		meta: lastRoute.meta,
		params: lastRoute.params,
		query: lastRoute.query
	};
	this.goTo(lastRoute.name, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'back-button-route',
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */]
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('route', ['getBreadCrumbs'])),
	methods: {
		backRoute: backRoute
	}
});

/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accounting_utils_help_component__ = __webpack_require__(827);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var appCode, uri, params, headers, _ref2, actions;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						appCode = 'quipu-admin';
						uri = this.resourceUri;
						params = {
							languages: 'es'
						};
						headers = {
							Accept: 'application/vnd.apiacl.v2+json'
						};
						_context.prev = 4;
						_context.next = 7;
						return this.$httpAcl.get('sidebar/' + appCode + '/resource/' + uri, { params: params, headers: headers });

					case 7:
						_ref2 = _context.sent;
						actions = _ref2.data;

						this.actions = actions.data.map(function (actionSingle) {
							var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, actionSingle);
							var index = _this.valueDisabled.findIndex(function (val) {
								return val.code === actionSingle.code;
							});
							newAction.name = actionSingle.languages;
							newAction.disabled = index > -1 && _this.valueDisabled[index].disabled;
							return newAction;
						});
						this.newActions = this.actions.splice(0, 3);
						this.actionComplete = actions.data;
						_context.next = 17;
						break;

					case 14:
						_context.prev = 14;
						_context.t0 = _context['catch'](4);

						this.showNotification('Recursos cargados', 'success');

					case 17:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 14]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.loadData();
}

function actionDisabled(values) {
	this.actions = this.actions.reduce(function (accum, act) {
		var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, act);
		var index = values.findIndex(function (v) {
			return v.code === act.code;
		});
		newAction.disabled = index > -1 && values[index].disabled;
		newAction.showMessage = index > -1 ? values[index].showMessage || false : false;
		newAction.message = index > -1 ? values[index].message : null;
		accum.push(newAction);
		return accum;
	}, []);
	this.newActions = this.newActions.reduce(function (accum, act) {
		var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, act);
		var index = values.findIndex(function (v) {
			return v.code === act.code;
		});
		newAction.disabled = index > -1 && values[index].disabled;
		newAction.showMessage = index > -1 ? values[index].showMessage || false : false;
		newAction.message = index > -1 ? values[index].message : null;
		accum.push(newAction);
		return accum;
	}, []);
}

function openAction(item) {
	if (!item.disabled) {
		if (item.code === 'HELP') {
			var helpIndex = this.actions.findIndex(function (act) {
				return act.code === item.code;
			});
			var newActions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.actions);
			newActions.splice(helpIndex, 1);
			var model = {
				code: item.code,
				actions: newActions
			};
			this.$emit('open-help', model);
		} else {
			this.$emit('run-action', item);
		}
	}
}

function openHelp() {
	this.action = {
		title: this.$route.meta.title,
		code: 'H',
		open: true,
		value: true,
		width: 500
	};
	this.helps = this.actionComplete;
}

function cancelModal() {
	this.action = {
		value: false,
		code: null,
		title: ''
	};
}

function openActionVertical() {
	this.showActionVertical = !this.showActionVertical;
}

function watchRoute(routeValue) {
	if (routeValue) {
		this.loadData();
	}
}

function data() {
	return {
		actions: [],
		helps: [],
		actionComplete: [],
		newActions: [],
		action: {
			value: false,
			code: '',
			open: false,
			title: '',
			width: 600
		},
		showActionVertical: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-actions',
	created: created,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__["a" /* default */],
		helpComponent: __WEBPACK_IMPORTED_MODULE_5__components_accounting_utils_help_component__["a" /* default */]
	},
	methods: {
		cancelModal: cancelModal,
		loadData: loadData,
		openAction: openAction,
		openHelp: openHelp,
		openActionVertical: openActionVertical
	},
	data: data,
	props: {
		resourceUri: {
			required: true,
			type: String
		},
		valueDisabled: {
			default: function _default() {
				return [];
			},
			type: Array
		}
	},
	watch: {
		valueDisabled: {
			deep: true,
			handler: actionDisabled
		},
		$route: watchRoute
	}
});

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'help-component',
	props: {
		helps: {
			type: Array,
			default: function _default() {
				return [];
			},
			required: true
		}
	}
});

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(114)('meta');
var isObject = __webpack_require__(31);
var has = __webpack_require__(44);
var setDesc = __webpack_require__(30).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(46)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(242);
var hiddenKeys = __webpack_require__(117).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(49);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 809:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_back_button_route_vue__ = __webpack_require__(796);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710017da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_button_route_vue__ = __webpack_require__(812);
function injectStyle (ssrContext) {
  __webpack_require__(810)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-710017da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_back_button_route_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710017da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_button_route_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(811);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("11adcb88", content, true, {});

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.back-button[data-v-710017da]{margin-left:50px}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/back-button-route.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,8BAA8B,gBAAgB,CAC7C","file":"back-button-route.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.back-button[data-v-710017da]{margin-left:50px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-tooltip-button',{staticClass:"back-button",attrs:{"img":'/static/img/icons/flecha_izquierda.svg',"width":25,"text":'Regresar'},on:{"click-icon":_vm.backRoute}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 824:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_actions_vue__ = __webpack_require__(800);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71471f8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_actions_vue__ = __webpack_require__(831);
function injectStyle (ssrContext) {
  __webpack_require__(825)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71471f8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_actions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71471f8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_actions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(826);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("4889eef0", content, true, {});

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.name-action[data-v-71471f8b]{color:#e0e5e8!important;font-family:Opens_semibold;font-size:13px}.btn-add-actions[data-v-71471f8b]{border:1px solid;border-radius:50%;height:25px;margin-left:14px;width:25px}.add-icon[data-v-71471f8b]{position:relative;top:3px}@media(max-width:760px){.app-actions[data-v-71471f8b]{display:none}}.border[data-v-71471f8b]{border:1px solid;height:15px;margin:0 0 0 15px}.width-content[data-v-71471f8b]{margin:0 0 0 auto;width:89%}.btn-add[data-v-71471f8b]{height:25px;width:24px}.btn-app-actions[data-v-71471f8b]{background-color:#fff;border:1px solid #02979b!important;border-radius:5px;-webkit-box-shadow:none;box-shadow:none;color:#02979b;font-family:Opens_semibold;font-size:12px;margin:6px;position:relative;text-transform:uppercase;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;width:160px}.btn-app-actions.disabled[data-v-71471f8b]{border:1px solid #c8c8c8!important;color:#c8c8c8!important;cursor:not-allowed}.btn-app-actions[data-v-71471f8b]:not(.disabled):hover{background-color:#02979b;color:#fff}.btn-app-actions:not(.disabled):hover .content-images-action .img-resource[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)}.message-action[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);display:none;font-size:12px;left:-95px;padding:15px;position:absolute;text-transform:none;top:51px;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;z-index:2;width:109%}.message-action[data-v-71471f8b]:before{background:#fff;border:1px solid;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:60%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.bold[data-v-71471f8b]{font-family:Opens_semibold}.message-action-list[data-v-71471f8b]{font-size:12px;position:absolute}.img-resource[data-v-71471f8b]{-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s}.img-resource.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)}.content-images-action.show-description:hover .img-resource-help[data-v-71471f8b],.content-images-action.show-description:hover .message-action[data-v-71471f8b]{display:block}.content-images-action.show-description:hover .img-resource[data-v-71471f8b]{display:none}.img-gray[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)}.img-white[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)}.img-resource-help[data-v-71471f8b]{display:none}.content-action-vertical[data-v-71471f8b]{position:relative}.content-list-action-vertical[data-v-71471f8b]{background-color:#fff;border:1px solid #ebebeb;border-radius:5px;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.05);box-shadow:0 2px 5px 0 rgba(0,0,0,.05);left:-135%;padding:6px;position:absolute;top:41px;width:197px;z-index:4}.content-list-action-vertical.open-action[data-v-71471f8b]{display:block}.content-list-action-vertical.close-action[data-v-71471f8b]{display:none}.content-list-action-vertical[data-v-71471f8b]:before{background:#fff;border:1px solid #ebebeb;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:41%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.content-btn-vertical[data-v-71471f8b]{padding:8px 0;display:-webkit-box;display:-ms-flexbox;display:flex}.content-btn-vertical-text[data-v-71471f8b]{color:#e0e5e8;font-size:12px;text-align:left;text-transform:uppercase}.content-btn-vertical-text.disabled[data-v-71471f8b]{color:#c8c8c8}.content-btn-vertical.disabled[data-v-71471f8b]{cursor:not-allowed}.img-veritical.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)}.content-image-message[data-v-71471f8b]{position:relative}.content-image-message:hover .message-action-vertical[data-v-71471f8b]{display:block}.content-image-message:hover .img-veritical[data-v-71471f8b]{display:none}.content-image-message:hover .img-resource-help-vertical[data-v-71471f8b]{display:block}.message-action-vertical[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);font-size:12px;display:none;padding:6px;position:absolute;right:29px;top:-14px;width:178px}.message-action-vertical[data-v-71471f8b]:before{background:#fff;border:1px solid;border-bottom-width:0;border-left-width:0;content:\"\";height:15px;position:absolute;right:-8px;top:11px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.img-resource-help-vertical[data-v-71471f8b]{display:none;height:24px}.new-indicator[data-v-71471f8b]{right:1px;position:absolute;top:.5px}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-actions/app-actions.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,8BAA8B,wBAAyB,2BAA6B,cAAc,CACjG,AACD,kCAAkC,iBAAiB,kBAAkB,YAAY,iBAAiB,UAAU,CAC3G,AACD,2BAA2B,kBAAkB,OAAO,CACnD,AACD,wBACA,8BAA8B,YAAY,CACzC,CACA,AACD,yBAAyB,iBAAiB,YAAY,iBAAiB,CACtE,AACD,gCAAgC,kBAAkB,SAAS,CAC1D,AACD,0BAA0B,YAAY,UAAU,CAC/C,AACD,kCAAkC,sBAAsB,mCAAoC,kBAAkB,wBAAwB,gBAAgB,cAAc,2BAA6B,eAAe,WAAW,kBAAkB,yBAAyB,0CAA0C,kCAAkC,WAAW,CAC5V,AACD,2CAA2C,mCAAoC,wBAAyB,kBAAkB,CACzH,AACD,uDAAuD,yBAAyB,UAAU,CACzF,AACD,4FAA4F,+BAA+B,uCAAuC,mCAAmC,CACpM,AACD,iCAAiC,sBAAsB,iBAAiB,kBAAkB,iDAAoD,yCAA4C,aAAa,eAAe,WAAW,aAAa,kBAAkB,oBAAoB,SAAS,0CAA0C,kCAAkC,UAAU,UAAU,CAC5X,AACD,wCAAyC,gBAAgB,iBAAiB,sBAAsB,qBAAqB,WAAW,YAAY,SAAS,kBAAkB,SAAS,WAAW,gCAAgC,uBAAuB,CACjP,AACD,uBAAuB,0BAA4B,CAClD,AACD,sCAAsC,eAAe,iBAAiB,CACrE,AACD,+BAA+B,0CAA0C,iCAAiC,CACzG,AACD,wCAAwC,uBAAuB,+BAA+B,2BAA2B,CACxH,AAGD,iKAAkF,aAAa,CAC9F,AACD,6EAA6E,YAAY,CACxF,AACD,2BAA2B,uBAAuB,+BAA+B,2BAA2B,CAC3G,AACD,4BAA4B,+BAA+B,uCAAuC,mCAAmC,CACpI,AACD,oCAAoC,YAAY,CAC/C,AACD,0CAA0C,iBAAiB,CAC1D,AACD,+CAA+C,sBAAsB,yBAAyB,kBAAkB,+CAA+C,uCAAuC,WAAW,YAAY,kBAAkB,SAAS,YAAY,SAAS,CAC5Q,AACD,2DAA2D,aAAa,CACvE,AACD,4DAA4D,YAAY,CACvE,AACD,sDAAuD,gBAAgB,yBAAyB,sBAAsB,qBAAqB,WAAW,YAAY,SAAS,kBAAkB,SAAS,WAAW,gCAAgC,uBAAuB,CACvQ,AACD,uCAAuC,cAAc,oBAAoB,oBAAoB,YAAY,CACxG,AACD,4CAA4C,cAAc,eAAe,gBAAgB,wBAAwB,CAChH,AACD,qDAAqD,aAAa,CACjE,AACD,gDAAgD,kBAAkB,CACjE,AACD,yCAAyC,uBAAuB,+BAA+B,2BAA2B,CACzH,AACD,wCAAwC,iBAAiB,CACxD,AACD,uEAAuE,aAAa,CACnF,AACD,6DAA6D,YAAY,CACxE,AACD,0EAA0E,aAAa,CACtF,AACD,0CAA0C,sBAAsB,iBAAiB,kBAAkB,iDAAoD,yCAA4C,eAAe,aAAa,YAAY,kBAAkB,WAAW,UAAU,WAAW,CAC5R,AACD,iDAAkD,gBAAgB,iBAAiB,sBAAsB,oBAAoB,WAAW,YAAY,kBAAkB,WAAW,SAAS,WAAW,gCAAgC,uBAAuB,CAC3P,AACD,6CAA6C,aAAa,WAAW,CACpE,AACD,gCAAgC,UAAU,kBAAkB,QAAQ,CACnE","file":"app-actions.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.name-action[data-v-71471f8b]{color:#e0e5e8 !important;font-family:\"Opens_semibold\";font-size:13px\n}\n.btn-add-actions[data-v-71471f8b]{border:solid 1px;border-radius:50%;height:25px;margin-left:14px;width:25px\n}\n.add-icon[data-v-71471f8b]{position:relative;top:3px\n}\n@media(max-width: 760px){\n.app-actions[data-v-71471f8b]{display:none\n}\n}\n.border[data-v-71471f8b]{border:1px solid;height:15px;margin:0 0 0 15px\n}\n.width-content[data-v-71471f8b]{margin:0 0 0 auto;width:89%\n}\n.btn-add[data-v-71471f8b]{height:25px;width:24px\n}\n.btn-app-actions[data-v-71471f8b]{background-color:#fff;border:1px solid #02979b !important;border-radius:5px;-webkit-box-shadow:none;box-shadow:none;color:#02979b;font-family:\"Opens_semibold\";font-size:12px;margin:6px;position:relative;text-transform:uppercase;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;width:160px\n}\n.btn-app-actions.disabled[data-v-71471f8b]{border:1px solid #c8c8c8 !important;color:#c8c8c8 !important;cursor:not-allowed\n}\n.btn-app-actions[data-v-71471f8b]:not(.disabled):hover{background-color:#02979b;color:#fff\n}\n.btn-app-actions:not(.disabled):hover .content-images-action .img-resource[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)\n}\n.message-action[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 rgba(157,157,157,.5);box-shadow:0 2px 4px 0 rgba(157,157,157,.5);display:none;font-size:12px;left:-95px;padding:15px;position:absolute;text-transform:none;top:51px;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;z-index:2;width:109%\n}\n.message-action[data-v-71471f8b]::before{background:#fff;border:1px solid;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:60%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.bold[data-v-71471f8b]{font-family:\"Opens_semibold\"\n}\n.message-action-list[data-v-71471f8b]{font-size:12px;position:absolute\n}\n.img-resource[data-v-71471f8b]{-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s\n}\n.img-resource.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)\n}\n.content-images-action.show-description:hover .message-action[data-v-71471f8b]{display:block\n}\n.content-images-action.show-description:hover .img-resource-help[data-v-71471f8b]{display:block\n}\n.content-images-action.show-description:hover .img-resource[data-v-71471f8b]{display:none\n}\n.img-gray[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)\n}\n.img-white[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)\n}\n.img-resource-help[data-v-71471f8b]{display:none\n}\n.content-action-vertical[data-v-71471f8b]{position:relative\n}\n.content-list-action-vertical[data-v-71471f8b]{background-color:#fff;border:solid 1px #ebebeb;border-radius:5px;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.05);box-shadow:0 2px 5px 0 rgba(0,0,0,.05);left:-135%;padding:6px;position:absolute;top:41px;width:197px;z-index:4\n}\n.content-list-action-vertical.open-action[data-v-71471f8b]{display:block\n}\n.content-list-action-vertical.close-action[data-v-71471f8b]{display:none\n}\n.content-list-action-vertical[data-v-71471f8b]::before{background:#fff;border:1px solid #ebebeb;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:41%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.content-btn-vertical[data-v-71471f8b]{padding:8px 0;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.content-btn-vertical-text[data-v-71471f8b]{color:#e0e5e8;font-size:12px;text-align:left;text-transform:uppercase\n}\n.content-btn-vertical-text.disabled[data-v-71471f8b]{color:#c8c8c8\n}\n.content-btn-vertical.disabled[data-v-71471f8b]{cursor:not-allowed\n}\n.img-veritical.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)\n}\n.content-image-message[data-v-71471f8b]{position:relative\n}\n.content-image-message:hover .message-action-vertical[data-v-71471f8b]{display:block\n}\n.content-image-message:hover .img-veritical[data-v-71471f8b]{display:none\n}\n.content-image-message:hover .img-resource-help-vertical[data-v-71471f8b]{display:block\n}\n.message-action-vertical[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 rgba(157,157,157,.5);box-shadow:0 2px 4px 0 rgba(157,157,157,.5);font-size:12px;display:none;padding:6px;position:absolute;right:29px;top:-14px;width:178px\n}\n.message-action-vertical[data-v-71471f8b]::before{background:#fff;border:1px solid;border-bottom-width:0;border-left-width:0;content:\"\";height:15px;position:absolute;right:-8px;top:11px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.img-resource-help-vertical[data-v-71471f8b]{display:none;height:24px\n}\n.new-indicator[data-v-71471f8b]{right:1px;position:absolute;top:.5px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_component_vue__ = __webpack_require__(801);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c459fd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_component_vue__ = __webpack_require__(830);
function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c459fd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c459fd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(829);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("7dbef01e", content, true, {});

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.help[data-v-6c459fd2]{font-size:14px}.article[data-v-6c459fd2]{margin:20px 0}.article-title[data-v-6c459fd2]{border-bottom:1px solid #fafcff;padding-bottom:8px}.article-description[data-v-6c459fd2]{margin:25px 0 10px}.list-none[data-v-6c459fd2]{list-style:none!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/accounting/utils/help-component.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,uBAAuB,cAAc,CACpC,AACD,0BAA0B,aAAa,CACtC,AACD,gCAAgC,gCAAgC,kBAAkB,CACjF,AACD,sCAAsC,kBAAkB,CACvD,AACD,4BAA4B,yBAA0B,CACrD","file":"help-component.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.help[data-v-6c459fd2]{font-size:14px\n}\n.article[data-v-6c459fd2]{margin:20px 0\n}\n.article-title[data-v-6c459fd2]{border-bottom:1px solid #fafcff;padding-bottom:8px\n}\n.article-description[data-v-6c459fd2]{margin:25px 0 10px\n}\n.list-none[data-v-6c459fd2]{list-style:none !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"help",attrs:{"row":"","mt-4":"","d-flex":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},_vm._l((_vm.helps),function(help,indexH){return _c('article',{key:indexH,staticClass:"article mb-3"},[_c('v-layout',{staticClass:"article-title",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('img',{attrs:{"src":help.pathIcon,"alt":help.languages}})]),_vm._v(" "),_c('v-flex',[_c('h3',[_vm._v(_vm._s(help.languages))])])],1),_vm._v(" "),_c('section',{staticClass:"article-description"},[_c('h4',{staticClass:"article-description_title"},[_vm._v("Descripción")]),_vm._v(" "),_c('p',{staticClass:"article-description_content"},[_vm._v(_vm._s(help.description))])]),_vm._v(" "),_c('span',[_c('h4',{staticClass:"article-description_title"},[_vm._v("Tutorial:")]),_vm._v(" "),_c('a',{attrs:{"href":help.link,"target":"_blank"}},[_vm._v(_vm._s(help.link))])]),_vm._v(" "),_c('h4',{staticClass:"article-description_title mt-2"},[_vm._v("Manuales:")]),_vm._v(" "),_c('ul',{staticClass:"list-none"},_vm._l((help.manuals),function(man,index){return _c('li',{key:index},[_c('a',{attrs:{"href":man.file,"target":"_blank"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(man.file)+"\n\t\t\t\t\t")])])}),0)],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"app-actions",attrs:{"justify-end":""}},[_c('v-layout',[_c('v-flex',[(this.actionComplete.length > 0)?_c('v-layout',{staticClass:"px-5 width-content",attrs:{"row":"","align-center":"","justify-end":""}},[_vm._l((_vm.newActions),function(item,index){return _c('div',{key:index,staticClass:"border-right"},[_c('button',{staticClass:"btn-app-actions",class:{ 'disabled': item.disabled },attrs:{"type":"button","color":"white"},on:{"click":function($event){return _vm.openAction(item)}}},[_c('v-layout',[_c('v-flex',{staticClass:"content-images-action",class:{'show-description': item.description.length > 0},attrs:{"xs2":"","py-2":"","pl-2":""}},[(item.pathIcon)?_c('img',{staticClass:"img-resource mr-2",class:{ 'disabled': item.disabled },attrs:{"src":item.pathIcon,"alt":item.name,"height":"16","width":"13"}}):_vm._e(),_vm._v(" "),(item.description.length > 0)?_c('img',{staticClass:"img-resource-help",class:[item.disabled ? 'img-gray' : 'img-white'],attrs:{"src":"/static/img/help-action.svg","alt":"ayuda","height":"15"}}):_vm._e(),_vm._v(" "),(item.description.length > 0)?_c('div',{staticClass:"message-action"},[_c('p',{staticClass:"mb-1 primary--text bold"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(item.description))])]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","py-2":"","pr-2":""}},[(item.flagNew)?_c('app-tooltip-button',{staticClass:"new-indicator",attrs:{"color":"info","height":"10","icon":"fiber_manual_record","text":item.newTitle || 'Nuevo'}}):_vm._e(),_vm._v(" "),(item.name.length > 14)?_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm._f("limitTo")(item.name,14)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])]):_c('span',[_vm._v(_vm._s(item.name))])],1)],1)],1)])}),_vm._v(" "),(this.actions.length > 0)?_c('div',{staticClass:"content-action-vertical"},[_c('v-btn',{staticClass:"btn-help",attrs:{"color":"primary","fab":"","small":""},on:{"click":_vm.openActionVertical}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-icon',{staticClass:"add-icon",attrs:{"slot":"activator","color":"white"},slot:"activator"},[_vm._v("add")]),_vm._v(" "),_c('span',[_vm._v("Mas opciones")])],1)],1),_vm._v(" "),_c('div',{staticClass:"content-list-action-vertical",class:[_vm.showActionVertical ? 'open-action' : 'close-action']},_vm._l((_vm.actions),function(item,index){return _c('div',{key:index},[_c('button',{staticClass:"content-btn-vertical",class:{'disabled': item.disabled},on:{"click":function($event){return _vm.openAction(item)}}},[_c('div',{staticClass:"mr-2 content-image-message"},[_c('div',[(item.pathIcon)?_c('img',{staticClass:"img-veritical",class:{'disabled': item.disabled},attrs:{"src":item.pathIcon,"alt":item.name,"height":"16","width":"13"}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img-resource-help-vertical",class:{'img-gray': item.disabled},attrs:{"src":"/static/img/help-action.svg","alt":"ayuda","height":"16","width":"13"}})]),_vm._v(" "),(item.description.length > 0)?_c('div',{staticClass:"message-action-vertical"},[_c('p',{staticClass:"mb-1 primary--text bold"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(item.description))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content-btn-vertical-text",class:{'disabled': item.disabled}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t\t\t")])])])}),0)],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"btn-help",attrs:{"color":"success","fab":"","small":""},on:{"click":_vm.openHelp}},[_c('img',{attrs:{"src":"/static/icon/btn-help-center.svg"}})])],2):_vm._e()],1)],1),_vm._v(" "),_c('action-sidebar',{attrs:{"help-actions":_vm.newActions,"title":_vm.action.title,"value":_vm.action.value,"width":_vm.action.width},on:{"close-modal":_vm.cancelModal}},[_c('help-component',{attrs:{"helps":_vm.helps}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNTING_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCOUNTING_DEFINITION_REMOVE; });
/* unused harmony export ACCOUNTING_DEFINITION_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ACCOUNTING_RULE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ACCOUNTING_RULE_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ACCOUNTING_PARAMETRIZATION; });
/* unused harmony export ACCOUNTING_MODULES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ACCOUNTING_MODULES_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ACCOUNTING_MODULES_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACCOUNTING_DICTIONARY_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ACCOUNTING_DICTIONARY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACCOUNTING_DICTIONARY_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACCOUNTING_DICTIONARY_NEW_ATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACCOUNTING_DICTIONARY_FORM_ATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ACCOUNTING_RULES_ASSIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return COSTS_CENTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return COSTS_CENTERS_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return COSTS_CENTERS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return IMPORT_ACCOUNTING_DEFINITION; });
var ACCOUNTING_DEFINITION = 'accounting-definitions';
var ACCOUNTING_DEFINITION_REMOVE = 'accounting-definitions-remove';
var ACCOUNTING_DEFINITION_LIST = 'accounting-definitions-list';
var ACCOUNTING_RULE_LIST = 'accounting-rules';
var ACCOUNTING_RULE_NEW = 'new-accounting-rules';
var ACCOUNTING_PARAMETRIZATION = 'accounting-parametrization';
var ACCOUNTING_MODULES = 'accounting-modules';
var ACCOUNTING_MODULES_FORM = 'new-accounting-module';
var ACCOUNTING_MODULES_REMOVE = 'accounting-modules-remove';
var ACCOUNTING_DICTIONARY_FORM = 'accounting-dictionary-form';
var ACCOUNTING_DICTIONARY_REMOVE = 'accounting-dictionary-remove';
var ACCOUNTING_DICTIONARY_NEW = 'new-accounting-dictionary';
var ACCOUNTING_DICTIONARY_NEW_ATS = 'create-account-data';
var ACCOUNTING_DICTIONARY_FORM_ATS = 'create-account-data';
var ACCOUNTING_RULES_ASSIGN = 'accounting-rules-assign';
var COSTS_CENTERS = 'costs-centers';
var COSTS_CENTERS_NEW = 'cost-center-new';
var COSTS_CENTERS_EDIT = 'cost-center-edit';
var IMPORT_ACCOUNTING_DEFINITION = 'import-accounting-definitions';

/***/ }),

/***/ 833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);




/* harmony default export */ __webpack_exports__["a"] = ({
	isEmpty: function isEmpty(arg) {
		if (Array.isArray(arg)) {
			return arg.length === 0;
		}
		if ((typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(arg)) === 'object' && arg !== null) {
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(arg).length === 0;
		}
		if (typeof arg === 'string' || typeof arg === 'number') {
			return !arg;
		}
		return !arg;
	},
	setNewProperty: function setNewProperty(property, value) {
		return function p(obj) {
			var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
			newObj[property] = typeof value === 'function' ? value(obj) : value;
			return newObj;
		};
	},

	map: function map(fn, col) {
		return col.map(fn);
	},
	getDeeper: function getDeeper() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return function inner(item) {
			var newItem = null;
			if (item && item.length) {
				var _item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(item, 1);

				newItem = _item[0];
			} else {
				newItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item);
			}
			args.forEach(function (el) {
				newItem = (newItem || {})[el];
			});
			return newItem;
		};
	}
});

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(845);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(847);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(846), __esModule: true };

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
__webpack_require__(111);
module.exports = __webpack_require__(794).f('iterator');


/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(848), __esModule: true };

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(849);
__webpack_require__(238);
__webpack_require__(853);
__webpack_require__(854);
module.exports = __webpack_require__(11).Symbol;


/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(12);
var has = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(25);
var $export = __webpack_require__(21);
var redefine = __webpack_require__(241);
var META = __webpack_require__(804).KEY;
var $fails = __webpack_require__(46);
var shared = __webpack_require__(116);
var setToStringTag = __webpack_require__(70);
var uid = __webpack_require__(114);
var wks = __webpack_require__(14);
var wksExt = __webpack_require__(794);
var wksDefine = __webpack_require__(795);
var enumKeys = __webpack_require__(850);
var isArray = __webpack_require__(806);
var anObject = __webpack_require__(18);
var isObject = __webpack_require__(31);
var toObject = __webpack_require__(48);
var toIObject = __webpack_require__(66);
var toPrimitive = __webpack_require__(235);
var createDesc = __webpack_require__(69);
var _create = __webpack_require__(239);
var gOPNExt = __webpack_require__(851);
var $GOPD = __webpack_require__(852);
var $GOPS = __webpack_require__(236);
var $DP = __webpack_require__(30);
var $keys = __webpack_require__(67);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(805).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(230).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(68)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(26)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(67);
var gOPS = __webpack_require__(236);
var pIE = __webpack_require__(230);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(66);
var gOPN = __webpack_require__(805).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(230);
var createDesc = __webpack_require__(69);
var toIObject = __webpack_require__(66);
var toPrimitive = __webpack_require__(235);
var has = __webpack_require__(44);
var IE8_DOM_DEFINE = __webpack_require__(240);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(25) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(795)('asyncIterator');


/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(795)('observable');


/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function created() {
	if (this.customerId) {
		this.newCustomerId = this.customerId;
		this.$emit('filter-customer', this.customerId, true);
	}
}

function search(value) {
	if (value) {
		var names = this.customerName.split(' ');
		var validName = names.every(function (n) {
			return n.toLowerCase() !== value.toLowerCase();
		});
		if (validName) {
			this.$emit('filter-customer', value);
		}
	}
}

function setCustomerId(_ref) {
	var id = _ref.id,
	    lastname = _ref.lastname,
	    name = _ref.name,
	    company = _ref.company;

	this.newCustomerId = id;
	var fullName = name + ' ' + lastname;
	this.$emit('set-customer-id', { id: id, fullName: fullName, company: company });
}

function data() {
	return {
		newCustomerId: 0,
		search: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'company-filter',
	created: created,
	data: data,
	methods: {
		setCustomerId: setCustomerId
	},
	props: {
		customerId: [Number, String],
		customerName: String,
		customers: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		disabled: {
			default: false,
			type: Boolean
		},
		isLoading: {
			default: false,
			type: Boolean
		}
	},
	watch: {
		search: search,
		$route: function $route(newVal) {
			if (newVal) {
				if (newVal.name === 'companies') {
					if (this.customerId) {
						this.newCustomerId = this.customerId;
						this.$emit('filter-customer', this.customerId, true);
					}
				}
			}
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.b409e8238bdabef1c9d8.js